import React, { Component } from 'react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Divider from 'material-ui/Divider';

// We can inject some CSS into the DOM.
const Props = (title, autoWidth) => ({
  maxHeight: 320,
  fullWidth: true,
  underlineShow: false,
  floatingLabelText: title,
  iconStyle: {
    fill: '#445981',
  },
  style: {
    fontSize: 16,
    fontWeight: 500,
    height: 70,
    padding: '0px 10px',
    boxShadow: '0px 0px 2px 2px transparent',
  },
  dropDownMenuProps: {
    autoWidth: autoWidth,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
  },
  floatingLabelShrinkStyle: {
    fontSize: 18
  },
  floatingLabelFocusStyle: {
    color: '#a0cef8',
    fontWeight: 500
  },
  floatingLabelStyle: {
    fontWeight: 400
  },
  underlineStyle: {
    margin: '-0px 0px -10px -10px'
  }
})

const PropsError = (result) =>  { //name, title, value
  const propsError = (result.isError) ? {
    floatingLabelText: result.message,
    style: {
      ...Props().style,
      //boxShadow: '0px 0px 2px 2px rgba(255, 0, 0, 0.5)',
      //border: '1px solid red'
    },
    floatingLabelStyle: {
      ...Props().floatingLabelStyle,
      color: 'red'
    },
    floatingLabelFocusStyle: {
      ...Props().floatingLabelFocusStyle,
      color: 'red'
    },
  } : { }
  return ({...propsError})
};

const GetError = (errors, name) => {
  let result = {isError: false}
  if (errors !== undefined){
    if (errors[name] !==undefined){
      result = errors[name]
    }
  }
  return (result)
}

class inputSelect extends Component {
  render() {
    const {title, name, value, array, onChange, autoWidth, section, errors} = this.props
    const devaultValue = (name !== undefined && value !== undefined)? {value: value[name]}: {}
    const id = section + name

    const props = {...devaultValue, ...Props(title, (autoWidth !== undefined)? autoWidth: false), ...PropsError(GetError(errors, id))}
    return (
      <div className='input-text'>
        <div className='input-text-container'>
          <SelectField id={id} {...props} onChange={(evt, index, value) => onChange(name, value, title, id)}>
            {array.map(({name, value}, index) => (name==='Divider')?
              <Divider key={index}/>
            :
              <MenuItem key={index} value={value} primaryText={name}/>
            )}
          </SelectField>
        </div>
      </div>
    )
  }
}

export default inputSelect



// WEBPACK FOOTER //
// ./src/shared/routes/components/inputSelect.js